export default __webpack_public_path__ + "static/media/Real-Benefit.bc191a0d.png";